import React from 'react';

import EditPromptForm from '../shared/EditPromptForm';

export default function EditAdmissionPrompt() {
  return (
    <EditPromptForm
      targetClassname='Review::Admission'
      promptLabel='Admission'
      backPath='/admin/admissions/prompts'
    />
  );
}
